import { PDP_DISPLAY_PRICE_SIMPLE_TYPE } from '@/components/blocks/HDMPriceDisplay/constants';
import {
	priceContainerStyles,
	superscriptStyles,
} from '@/components/blocks/HDMPriceDisplay/style/priceCard';
import { PriceVariant } from '@/components/blocks/HDMPriceDisplay/types';
import { mergeSx } from '@/utils/mergeSx';
import { Box, SxProps, Theme, Typography } from '@mui/material';
import { FC } from 'react';

export const FormatPrice: FC<{
	price: number;
	type?: string;
	variant?: PriceVariant;
	fontWeight?: number;
	sx?: SxProps<Theme>;
	id?: string;
}> = ({ price, type, variant = 'md', fontWeight, sx, id }) => {
	const formattedString = new Intl.NumberFormat('en-US', {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	}).format(price);
	const [dollars, cents] = formattedString.split('.');

	return type === PDP_DISPLAY_PRICE_SIMPLE_TYPE ? (
		<>
			${dollars}.{cents}
		</>
	) : (
		<Box sx={mergeSx(priceContainerStyles(variant, fontWeight), sx)} id={id}>
			<Typography component="sup" sx={superscriptStyles(true)}>
				$
			</Typography>
			<Box component="span">{dollars}</Box>
			<Typography component="sup" sx={superscriptStyles(false)}>
				{cents}
			</Typography>
		</Box>
	);
};
